export default {
	agreementStatusTransitionFailed: "Не удалось перевести заявку в статус {status}",
	agreementTransitionFailed: "Не удалось выполнить переход {transitionCode}",
	classNameContainsSpace: "className не должен содержать пробелы.",
	console: {
		browserNotificationsInitializationFailed: "Ошибка инициализации браузерных уведомлений:",
		copyFailed: "Ошибка копирования:",
		executorColorNotDefined: "Для ответственного {value} не определен color",
		propertyAssignmentRouteWithoutResourceStep: "Маршрут назначения имущества открыт для услуги без этапа назначения ресурса",
		propertyAssignmentTransitionNotAllowed: "Переход назначения имущества доступен, но профиль услуги не допускает назначение",
		serviceApplicationCreationFailed: "Ошибка создания заявки: {serviceName}",
		serviceDocumentsUploadFailed: "Ошибка загрузки документов: {serviceName}",
		serviceTypeNotSet: "Вид услуги не задан",
		serviceWorkerNotSupported: "Service Worker не поддерживается",
		serviceWorkerRegistrationFailed: "Ошибка регистрации Service Worker:",
		serviceWorkerUnregistrationFailed: "Ошибка отмены регистрации Service Worker:",
		statusColorNotDefined: "Для статуса {value} не определен color",
		storeAlreadyInitialized: "store уже инициализирован",
		tariffCostCalculationFailed: "Ошибка расчёта стоимости тарифа",
		totalServiceCostCalculationFailed: "Ошибка расчёта общей стоимости услуги",
		unknownServiceWorkflowTransition: "Неизвестный переход процесса оказания услуги: {code}"
	},
	documentTransitionNotAvailable: "Переход документа {transitionCode} недоступен для текущего состояния услуги",
	documentTransitionNotSupported: "Переход документа {transitionCode} не поддерживается сгенерированным перечислением этапов услуги",
	responseFileNameInvalid: "Сервер не передал корректное имя файла в заголовке Content-Disposition",
	durationExceedsMaximum: "Продолжительность превышает 99 часов (получено {totalHours}). Невозможно отформатировать в формате \"HH:MM\".",
	fileSizeForSignatureExceeded: "Файл для подписи не должен превышать {maxSizeMb} МБ",
	invalidCalendarDate: "Некорректная календарная дата: {value}",
	invalidLocalTime: "Некорректное локальное время: {value}",
	invalidLocalDateTime: "Некорректные локальные дата и время: {value}",
	invalidDurationDays: "Неверное значение дней: \"{dayPart}\" в \"{timespan}\".",
	invalidTimeSpanFormat: "Неверный формат строки: \"{timespan}\". Ожидается формат \"d.HH:MM:SS\", \"HH:MM:SS\" или \"HH:MM\".",
	invalidTimeSpanValue: "Неверное значение времени в строке: \"{timespan}\".",
	loginRedirectUriInvalid: "Не удалось выполнить вход: redirectUri отсутствует или некорректен",
	loginRedirectUriOrProfilesInvalid: "Не удалось выполнить вход: redirectUri или profiles отсутствуют либо некорректны",
	pageBeforeInitializedHookNotDefined: "Хук beforeInitialized не был определен",
	phoneConfirmation: "Телефон отсутствует или уже подтвержден",
	profileNotFound: "Профиль не найден",
	recipientFilterInvalidAgreementTransition: "Фильтр получателей не соответствует типу ApiAgreementTransitionFilter",
	recipientFilterInvalidRoles: "Фильтр получателей не соответствует типу ApiRolesRecipientFilter",
	recipientFilterInvalidServiceTransition: "Фильтр получателей не соответствует типу ApiServiceApplicationTransitionFilter",
	routeToPermissionsMapMissingKey: "Матрица RouteToPermissionsMap не содержит ключ {key}",
	selectedPortIsArchived: "Выбранный порт находится в архиве",
	serviceApplicationStartDateTimeRequired: "Необходимо указать дату и время начала оказания услуг",
	serviceApplicationStartDateRequired: "Необходимо указать дату начала оказания услуг",
	serviceApplicationPortRequired: "Выберите порт оказания услуги",
	serviceApplicationLegalBasisKindRequired: "Выберите правовое основание для оформления заявки",
	serviceApplicationTillAfterFrom: "Время окончания должно быть позже времени начала",
	serviceDefinitionRequired: "Перед подготовкой заявки необходимо выбрать шаблон услуги",
	servicePresentationNotConfigured: "Представление услуги не настроено для вида услуги {serviceType}",
	serviceTypeNotSet: "Вид услуги не задан",
	signInWithProfileRedirectUriInvalid: "Не удалось выполнить вход с профилем: redirectUri отсутствует или некорректен",
	tooManyRequests: "Число повторных попыток обращения к серверу превысило допустимое значение.",
	useVuetifyOutsideSetup: "useVuetify должен вызываться в setup().",
	failedPreviewDocument: "Не удалось открыть предпросмотр документа. Скачайте файл для просмотра."
};
